module.exports = __webpack_public_path__ + "media/images/link-arrow-9ff14285.svg";